import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { DateTimeInput } from "@common/dateTimeInput";
import { TrashIcon } from "@common/trashIcon";
import { useRemoveHoliday } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function Holiday({ holiday, onChange, onRemove }: Props) {
  const { isRequestPending, removeHoliday } = useRemoveHoliday(holiday);
  const { t } = useTranslation();
  const userTimezone = DateTime.local().zoneName;
  const [name, setName] = useState(holiday.name);
  const [day, setDay] = useState<string>(holiday.day);
  const [holidayDate, setHolidayDate] = useState<string>(holiday.holidayDate);
  const editDate = (newDate: string) => {
    const dt = DateTime.fromISO(newDate, { zone: "utc" }).setZone(userTimezone);
    if (!dt.isValid) return;
    setDay(dt.toUTC().toISO() ?? "");
    setHolidayDate(dt.toFormat("yyyy-MM-dd"));
  };
  const remove = () => {
    holiday.uuid && removeHoliday(holiday);
    onRemove();
  };

  useEffect(() => {
    onChange({ ...holiday, name, day, holidayDate });
  }, [name, day, holidayDate]);

  return (
    <div className={styles.holidayForm}>
      <div className={styles.holidayRow}>
        <TextInput
          placeholder={t(
            "calendarHolidays.edition.holidayEdition.namePlaceholder",
          )}
          value={name}
          input={setName}
          className={styles.holidayNameInput}
        />

        <DateTimeInput
          dateTime={
            holidayDate
              ? (DateTime.fromISO(holidayDate, { zone: userTimezone })
                  .toUTC()
                  .toISO() ?? "")
              : ""
          }
          placeholder={t(
            "calendarHolidays.edition.holidayEdition.datePlaceholder",
          )}
          input={editDate}
        />

        <button
          type="button"
          className={styles.removeButton}
          disabled={isRequestPending}
          onClick={remove}
        >
          <TrashIcon className={classNames(styles.icon, styles.removeIcon)} />
        </button>
      </div>
    </div>
  );
}

export { Holiday };
